import { ClipLoader } from "react-spinners";
import "./Loading.scss";

export default function Loading(props) {
  return (
    <>
      {props.show && (
        <div className={`${props?.individual ? "" : "divLoading"}`}>
          <ClipLoader color="var(--color-01)" size={props?.size ?? 30} />
        </div>
      )}
    </>
  );
}
